import React from 'react';
import ComputeDetailsTableBase from './ComputeDetailsTableBase';

const ComputeCountTable: React.FC = () => {
  return (
    <ComputeDetailsTableBase
      defaultTitle="Compute Count Details"
      showComputeCount={true}
    />
  );
};

export default ComputeCountTable;